/**
 * contentValidators/shared.ts — Shared constants and types for content stage validators.
 */

import type { PipelineStage } from '../../issueContract';
export const STAGE: PipelineStage = 3;